export default __webpack_public_path__ + "static/media/ic-unfold.4752ea4f.svg";